import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
// import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import fastapi from "../assets/fastapi.png";
import django from "../assets/django.png"
import nibble from "../assets/nibble.png";
import metlab from "../assets/metlab.png";
import solidity from "../assets/solidity.png";
import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

import page404 from '../assets/404.png';
import taskcyapi from '../assets/taskcyapi.png';
import taskcy from '../assets/taskcy.png';
import simplegallary from '../assets/simplegallary.png';
import restaurant from '../assets/restaurant.png';
import portfoliov1 from '../assets/portfoliov1.png';
import nibble1 from '../assets/nibble1.png';
import mainstack from '../assets/mainstack.png';
import metlab2 from '../assets/metlab2.png';
import interior from '../assets/interior.png';
import gpt3 from '../assets/gpt3.png';
import etest from '../assets/etest.png';
import ecommace from '../assets/ecommace.png';
import dashboard from '../assets/dashboard.png';
import creativecrew from '../assets/creativecrew.png';
import checkout from '../assets/checkout.png';
import cheesecake from '../assets/cheesecake.png';


const images = {
  page404,
  taskcyapi,
  taskcy,
  simplegallary,
  restaurant,
  portfoliov1,
  nibble1,
  mainstack,
  metlab2,
  interior,
  gpt3,
  etest,
  ecommace,
  dashboard,
  creativecrew,
  checkout,
  cheesecake,
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  // circle,
  fastapi,
  django,
  solidity,
  nibble,
  metlab,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};

export default images;
